import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    :host {
        display: block;
    }

    .container {
        display: flex;
        flex-direction: column;
    }

    .desc {
        font-style: italic;
        font-size: smaller;
    }

    span {
        color: black;
    }

    ds-warning-icon {
        min-width: 1.5em;
    }
`;
